import React from 'react';

/**
 * FunderAcknowledgment — Rotary funding acknowledgment
 * @param {Object} props
 * @param {'compact'|'full'} props.variant - 'compact' for sidebars/navs, 'full' for page footers (default)
 */
export default function FunderAcknowledgment({ variant = 'full', as: Tag = 'footer' }) {
  if (variant === 'compact') {
    return (
      <div className="flex items-center justify-center gap-2 px-3 py-2">
        <img src="/logos/rotary logo.png" alt="Rotary" className="h-5 w-auto opacity-70" />
        <span className="text-[10px] text-gray-400 leading-tight">Supported by Rotary</span>
      </div>
    );
  }

  return (
    <Tag className="py-6 px-4 print:hidden">
      <div className="flex flex-col items-center justify-center gap-2 max-w-lg mx-auto">
        <img
          src="/logos/rotary logo.png"
          alt="Rotary"
          className="h-9 w-auto opacity-80"
        />
        <p className="text-xs text-gray-500 text-center leading-relaxed">
          We gratefully acknowledge funding from Rotary Global Grant (RID 3132) — Rotary Club of Jalna, Hudson Valley & Austin, and Cigna Healthcare Austin
        </p>
      </div>
    </Tag>
  );
}
